module.exports = __webpack_public_path__ + "img/brillante_9.f4327ff8.svg";